import { FC } from "react"
import { FormSearchRightProps } from "./models"
import { Styled } from "./styled"

const { StyledFormSearchRight } = Styled

export const FormSearchRight: FC<FormSearchRightProps> = ({
  children,
  ...res
}) => (
  <StyledFormSearchRight className="form-search-right" {...res}>
    {children}
  </StyledFormSearchRight>
)
